import * as React from "react";
import type { SVGProps } from "react";
const SvgEmail = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={64}
    height={64}
    fill="none"
    {...props}
  >
    <path
      stroke="#26A3DD"
      strokeWidth={1.75}
      d="M58.815 52.005H5.185c-1.75 0-3.19-1.43-3.19-3.19v-33.63c0-.88.36-1.67.94-2.25.58-.58 1.37-.94 2.25-.94h53.63c1.75 0 3.19 1.43 3.19 3.19v33.63c0 1.75-1.43 3.19-3.19 3.19Z"
    />
    <path
      fill="#D3ECF8"
      stroke="#26A3DD"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.75}
      d="m59.124 12.335-27.16 19.9-27.07-20.09 54.23.19Z"
    />
    <path
      fill="#26A3DD"
      d="M25.715 41.945c0-3.52 2.87-6.37 6.39-6.37 3.81 0 6.29 2.8 6.29 5.73 0 1.94-1 3.55-2.79 3.55-.99 0-1.65-.41-1.99-.94-.42.56-1.17.95-2.18.95-1.39 0-2.86-1.1-2.65-3.08.24-2.07 1.78-3.04 3.06-3.04.78 0 1.39.29 1.77.73.05-.56.05-.63.05-.63h1.58l-.34 3.08c-.1.95.15 1.39.82 1.39.71 0 1.14-.82 1.14-2.01 0-2.14-1.85-4.25-4.76-4.25-2.69 0-4.83 2.19-4.83 4.88s2.09 4.88 4.78 4.88c1.41 0 2.63-.58 3.52-1.51l1.16.97a6.41 6.41 0 0 1-4.67 2.04c-3.52 0-6.34-2.84-6.34-6.38l-.01.01Zm7.68-.17c.1-.87-.41-1.61-1.29-1.61-.88 0-1.63.65-1.7 1.6-.12.92.49 1.65 1.38 1.65.89 0 1.53-.75 1.61-1.63v-.01Z"
    />
  </svg>
);
export default SvgEmail;
